import FeedbackEdit from "./edit.vue";
import FeedbackList from './list.vue'
let a = Object.assign({FeedbackEdit, FeedbackList}, {})
export default a;
